import { IconCube, IconStack2 } from "@tabler/icons-react";
import ButtonGroups, { BGItem } from "components/ButtonGroups";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { productSearchStore as store } from "../ProductSearchStore";
import { ProductSourceEnum, ProductTypeChoicesEnum } from "api-client";
import useFeatureFlag from "hooks/useFeatureFlag";

const SOURCE_TYPES = [
  "all",
  ProductSourceEnum.Manufacturer,
  ProductSourceEnum.Concular,
  ProductSourceEnum.Custom,
];

const PRODUCT_TYPES = [
  "all",
  ProductTypeChoicesEnum.Product,
  ProductTypeChoicesEnum.Component,
];

const TabSelection = () => {
  const { t } = useTranslation();
  const { isFeatureVisible } = useFeatureFlag();
  const [sourceTypes, setSourceTypes] = React.useState<BGItem[]>([]);
  const [productTypes, setProductTypes] = React.useState<BGItem[]>([]);

  const onChangeSourceType = (item?: BGItem) => {
    store.resetSearchTable();
    store.updateSearchInput(
      "product_source",
      item?.id === "all" ? null : (item?.id as ProductSourceEnum)
    );
  };

  const onChangeProductType = (item?: BGItem) => {
    store.resetSearchTable();
    store.updateSearchInput(
      "type",
      item?.id === "all" ? null : (item?.id as ProductTypeChoicesEnum)
    );
  };

  const getSourceTypes = () => {
    return SOURCE_TYPES.map((item) => {
      return {
        id: item,
        name: t("productSearch." + item),
        hidden:
          !isFeatureVisible("manufacturer_products_tab") &&
          item === ProductSourceEnum.Manufacturer,
      };
    });
  };

  const getProductTypes = () => {
    return PRODUCT_TYPES.map((item) => {
      const icon =
        item === "PRODUCT" ? (
          <IconCube width={18} stroke={2.5} className="text-gray-500" />
        ) : (
          <IconStack2 width={18} stroke={2.5} className="text-gray-500" />
        );

      return {
        id: item,
        name: t("productSearch." + item),
        icon: item === "ALL" ? undefined : icon,
      };
    });
  };

  React.useEffect(() => {
    setSourceTypes(getSourceTypes());
    setProductTypes(getProductTypes());
  }, []);

  return (
    <div className="flex items-center w-full gap-4 mb-6 flex-col lg:flex-row">
      {!store.isManufacturerLicence && (
        <ButtonGroups
          items={sourceTypes.filter((rec) => !rec.hidden)}
          current={sourceTypes[0]}
          onChange={onChangeSourceType}
          optionClsssName="!h-9 whitespace-nowrap"
          containerClassName="w-full"
        />
      )}

      <ButtonGroups
        items={productTypes}
        current={productTypes[0]}
        onChange={onChangeProductType}
        optionClsssName="!h-9 whitespace-nowrap"
        containerClassName="w-full"
      />
    </div>
  );
};

export default observer(TabSelection);
